import { useMutation, useQueryClient } from "@tanstack/react-query"

import type { FlowPromptItem, FlowPromptResponse, UpsertFlowPromptRequest } from "@/api/models"

import { api } from "@/lib/api-client"
import { queryKeys } from "@/lib/query-keys"

function upsertFlowPrompt(data: UpsertFlowPromptRequest): Promise<FlowPromptItem> {
  return api.post("/explorer/flow-prompt", data)
}

export function useUpsertFlowPrompt() {
  const queryClient = useQueryClient()

  const upsertFlowPromptMutation = useMutation({
    mutationKey: queryKeys.upsertFlowPrompt,
    mutationFn: (data: UpsertFlowPromptRequest) => upsertFlowPrompt(data),
    onSuccess: (prompt) => {
      queryClient.setQueryData<FlowPromptResponse>(queryKeys.flowPrompts, (current) => {
        const existing = current?.prompts ?? []
        const existingIndex = existing.findIndex((item) => item.id === prompt.id)

        if (existingIndex === -1) {
          return { prompts: [prompt, ...existing] }
        }

        return {
          prompts: existing.map((item, index) => (index === existingIndex ? prompt : item)),
        }
      })
    },
  })

  return upsertFlowPromptMutation
}
